(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var dataEl = document.getElementById('patch-design-data');
    var root = document.getElementById('chain-builder');
    if (!root || !dataEl) return;

    var designs;
    try {
      designs = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!designs || !designs.length) return;

    var mode = root.getAttribute('data-mode') || 'fixed';
    var target = parseInt(root.getAttribute('data-target'), 10) || 24;
    var perDesign = parseInt(root.getAttribute('data-per-design'), 10) || 12;
    var minCheckout = parseInt(root.getAttribute('data-min-checkout'), 10) || 12;
    var bundleVariantId = root.getAttribute('data-bundle-variant');
    var fixedId1 = root.getAttribute('data-fixed-design-1');
    var fixedId2 = root.getAttribute('data-fixed-design-2');
    var progressTemplate = root.getAttribute('data-progress-template') || 'Add %n% more to complete the chain!';
    var progressComplete = root.getAttribute('data-progress-complete') || 'Chain complete! 🎉';
    var scentLabel = root.getAttribute('data-scent-label') || '🌿 Botanical oils infused:';
    var addButtonText = root.getAttribute('data-add-button-text') || 'Add 2x to chain';
    var lockedNote = root.getAttribute('data-locked-note') || 'Included in every fixed chain';
    var unavailableNote = root.getAttribute('data-unavailable-note') || 'Not in this chain — full mixing coming soon!';

    var svgFor = {};
    document.querySelectorAll('template[data-patch-template]').forEach(function (tpl) {
      svgFor[tpl.getAttribute('data-patch-template')] = tpl.innerHTML.trim();
    });

    function artFor(id) {
      var d = findDesign(id);
      if (d && d.image) {
        return '<img src="' + d.image + '" alt="' + (d.label || '') + '" loading="lazy">';
      }
      return svgFor[id] || '';
    }

    function findDesign(id) {
      for (var i = 0; i < designs.length; i++) if (designs[i].id === id) return designs[i];
      return designs[0];
    }

    var chain = {};
    var selectedId;

    if (mode === 'fixed' && fixedId1) {
      chain[fixedId1] = perDesign;
      if (fixedId2) chain[fixedId2] = perDesign;
      selectedId = fixedId1;
    } else {
      // custom mode starts empty; default inspected design is the 2nd in the collection
      selectedId = designs[Math.min(1, designs.length - 1)].id;
    }

    var selectorEl = document.getElementById('chain-selector');
    var inspectEl = document.getElementById('chain-inspect-card');
    var totalEl = document.getElementById('chain-total');
    var fillEl = document.getElementById('chain-progress-fill');
    var noteEl = document.getElementById('chain-progress-note');
    var charmsEl = document.getElementById('chain-charms');
    var emptyNote = document.getElementById('chain-empty-note');
    var checkoutBtn = document.getElementById('chain-checkout');

    renderSelector();
    renderInspectCard();
    renderChain();

    function renderSelector() {
      selectorEl.innerHTML = '';
      designs.forEach(function (d) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pouch-pill' + (d.id === selectedId ? ' is-active' : '');
        btn.setAttribute('data-id', d.id);
        btn.innerHTML =
          '<span class="pouch-pill__art">' + artFor(d.id) + '</span>' +
          '<span class="pouch-pill__label">' + d.shortLabel + '</span>';
        btn.addEventListener('click', function () {
          selectedId = d.id;
          renderSelector();
          renderInspectCard();
        });
        selectorEl.appendChild(btn);
      });
    }

    function renderInspectCard() {
      var d = findDesign(selectedId);
      var isFixedIncluded = mode === 'fixed' && (d.id === fixedId1 || d.id === fixedId2);
      var actionHtml;

      if (mode === 'custom') {
        actionHtml =
          '<button type="button" class="bopi-btn bopi-btn-primary pouch-add-btn" id="chain-add-btn">' +
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" x2="12" y1="5" y2="19"/><line x1="5" x2="19" y1="12" y2="12"/></svg>' +
            '<span>' + addButtonText + '</span>' +
          '</button>';
      } else if (isFixedIncluded) {
        actionHtml = '<div class="chain-inspect-note chain-inspect-note--locked">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6 9 17l-5-5"/></svg>' +
          '<span>' + lockedNote + '</span></div>';
      } else {
        actionHtml = '<div class="chain-inspect-note chain-inspect-note--unavailable">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/></svg>' +
          '<span>' + unavailableNote + '</span></div>';
      }

      inspectEl.innerHTML =
        '<div class="pouch-inspect-card__art">' + artFor(d.id) + '</div>' +
        '<div class="pouch-inspect-card__body">' +
          '<span class="pouch-inspect-card__tag">' + d.label + '</span>' +
          '<h4>' + d.label + '</h4>' +
          '<p class="pouch-inspect-card__story">' + (d.story || '') + '</p>' +
          '<div class="pouch-inspect-card__scent">' +
            '<span class="pouch-inspect-card__scent-label">' + scentLabel + '</span>' +
            '<span>' + d.scent + '</span>' +
          '</div>' +
          actionHtml +
        '</div>';

      if (mode === 'custom') {
        document.getElementById('chain-add-btn').addEventListener('click', function () {
          changeQty(d.id, 2);
        });
      }
    }

    function changeQty(id, delta) {
      if (mode !== 'custom') return;
      chain[id] = Math.max(0, Math.min(10, (chain[id] || 0) + delta));
      renderChain();
    }

    function total() {
      return Object.keys(chain).reduce(function (sum, k) { return sum + chain[k]; }, 0);
    }

    function renderChain() {
      var t = total();
      totalEl.textContent = t;
      fillEl.style.width = Math.min((t / target) * 100, 100) + '%';

      if (t >= target) {
        noteEl.textContent = progressComplete;
      } else {
        noteEl.textContent = progressTemplate.replace('%n%', target - t);
      }

      charmsEl.innerHTML = '';
      var any = false;
      designs.forEach(function (d) {
        var qty = chain[d.id] || 0;
        if (qty === 0) return;
        any = true;

        var charm = document.createElement('div');
        charm.className = 'chain-charm';
        charm.innerHTML =
          '<span class="chain-charm__ring"></span>' +
          '<div class="chain-charm__body">' +
            '<div class="chain-charm__window">' + artFor(d.id) + '</div>' +
            '<span class="chain-charm__name">' + d.shortLabel + '</span>' +
          '</div>' +
          '<div class="chain-charm__qty">' +
            (mode === 'custom'
              ? '<button type="button" class="pouch-item__btn" data-action="dec">−</button><span>' + qty + '</span><button type="button" class="pouch-item__btn" data-action="inc">+</button>'
              : '<span class="chain-charm__qty-badge">×' + qty + '</span>')
          + '</div>';

        if (mode === 'custom') {
          charm.querySelector('[data-action="dec"]').addEventListener('click', function () { changeQty(d.id, -2); });
          charm.querySelector('[data-action="inc"]').addEventListener('click', function () { changeQty(d.id, 2); });
        }

        charmsEl.appendChild(charm);
      });

      if (!any) charmsEl.appendChild(emptyNote);

      if (mode === 'custom') {
        checkoutBtn.disabled = t < minCheckout;
      }
    }

    checkoutBtn.addEventListener('click', function () {
      if (checkoutBtn.disabled || !bundleVariantId || !window.BopiCart) return;

      var mix = designs
        .filter(function (d) { return (chain[d.id] || 0) > 0; })
        .map(function (d) { return d.label + ' x' + chain[d.id]; })
        .join(', ');

      checkoutBtn.disabled = true;
      checkoutBtn.querySelector('span').textContent = 'Adding…';

      window.BopiCart.addToCart({
        variantId: bundleVariantId,
        quantity: 1,
        attributes: mode === 'custom' ? { 'Chain mix': mix } : null,
        openCart: false
      }).then(function (result) {
        if (result.ok) {
          window.location.href = '/checkout';
        } else {
          checkoutBtn.disabled = mode === 'custom' ? total() < minCheckout : false;
          checkoutBtn.querySelector('span').textContent = 'Try again';
        }
      });
    });
  });
})();
